import type { UserPreferences } from '@court-sync/shared';

export type UpsellTourKind = 'club' | 'professional' | 'enterprise';

export type TourSession =
  | {
      kind: 'page';
      completionKey: string;
      onFinish?: () => void;
    }
  | {
      kind: 'upsell';
      upsellKind: UpsellTourKind;
    }
  | {
      kind: 'dashboard';
      preferences: Partial<UserPreferences>;
    };

let activeSession: TourSession | null = null;

export function beginTourSession(session: TourSession): void {
  activeSession = session;
}

export function clearTourSession(): void {
  activeSession = null;
}

export function getActiveTourSession(): TourSession | null {
  return activeSession;
}
